import React, { useState, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import cx from 'classnames';
import { useLocation } from 'react-router';
import CaretDownFilledIcon from '@/components/icons/CaretDownFilledIcon';
import { HeaderItem } from '@/hooks/header';
import cs from './index.module.scss';
import { useStore } from '@/models';

export const MenuItem = (props: HeaderItem) => {
  const { account,ui } = useStore();
  const { isLogin } = account;

  const { title, children, url, baseUrl, onClick } = props;
  const [visible, setVisible] = useState(true);
  const { pathname } = useLocation();

  const rotate180 = useMemo(() => ({ [cs.rotate180]: !visible }), [visible]);
  const hidden = useMemo(() => ({ [cs.hidden]: visible }), [visible]);

  return (
    <>
      <a
        className={cx(cs.menuItem, { [cs.active]: baseUrl && pathname.includes(baseUrl) })}
        href={children ? undefined : url}
        onClick={event => {
          event.stopPropagation();
          if (children) setVisible(v => !v);
        }}
      >
        {title}

        {children ? <CaretDownFilledIcon className={cx(cs.icon, rotate180)} /> : null}
      </a>

      {children ? (
        <div className={cx(hidden)}>
          {children?.map(item => (
            <a
              key={item.title}
              className={cs.menuItemChildren}
              href={item?.url}
              onClick={event => {
                event.stopPropagation();
                onClick && onClick(item);
              }}
            >
              {item?.title}
            </a>
          ))}
        </div>
      ) : null}
    </>
  );
};

export default observer(MenuItem);
